export default __webpack_public_path__ + "static/media/18.13dfdf75.gif";